import { createSlice } from '@reduxjs/toolkit';
import { SalaryTransactionState } from './salaryTransactionTypes';
import {
    createSalaryTransaction,
    fetchSalaryTransactions,
    fetchSalaryTransactionById,
    updateSalaryTransaction,
    deleteSalaryTransaction,
    fetchSalaryTransactionsByEmployeeId
} from './salaryTransactionActions';

const initialState: SalaryTransactionState = {
    salaryTransactions: [],
    salaryTransactionsByEmployee: [],
    selectedTransaction: undefined,
    loading: false,
    error: undefined,
};

const salaryTransactionSlice = createSlice({
    name: 'salaryTransaction',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // Create Salary Transaction
            .addCase(createSalaryTransaction.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(createSalaryTransaction.fulfilled, (state, action) => {
                state.loading = false;
                state.salaryTransactions.push(action.payload);
            })
            .addCase(createSalaryTransaction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch All Salary Transactions
            .addCase(fetchSalaryTransactions.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchSalaryTransactions.fulfilled, (state, action) => {
                state.loading = false;
                state.salaryTransactions = action.payload.data;
            })
            .addCase(fetchSalaryTransactions.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Fetch Salary Transaction by ID
            .addCase(fetchSalaryTransactionById.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchSalaryTransactionById.fulfilled, (state, action) => {
                state.loading = false;
                state.selectedTransaction = action.payload;
            })
            .addCase(fetchSalaryTransactionById.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Update Salary Transaction
            .addCase(updateSalaryTransaction.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(updateSalaryTransaction.fulfilled, (state, action) => {
                state.loading = false;
                const index = state.salaryTransactions.findIndex(transaction => transaction.id === action.payload.id);
                if (index !== -1) {
                    state.salaryTransactions[index] = action.payload;
                }
            })
            .addCase(updateSalaryTransaction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })

            // Delete Salary Transaction
            .addCase(deleteSalaryTransaction.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(deleteSalaryTransaction.fulfilled, (state, action) => {
                state.loading = false;
                state.salaryTransactions = state.salaryTransactions.filter(transaction => transaction.id !== action.payload.id);
            })
            .addCase(deleteSalaryTransaction.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            })
            // Fetch Salary Transactions by Employee ID
            .addCase(fetchSalaryTransactionsByEmployeeId.pending, (state) => {
                state.loading = true;
                state.error = undefined;
            })
            .addCase(fetchSalaryTransactionsByEmployeeId.fulfilled, (state, action) => {
                state.loading = false;
                state.salaryTransactionsByEmployee = action.payload.data;
            })
            .addCase(fetchSalaryTransactionsByEmployeeId.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload as string;
            });
    },
});

export default salaryTransactionSlice.reducer;
